import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NextFrame = _resolveComponent("NextFrame")!

  return (_openBlock(), _createBlock(_component_NextFrame, {
    path: "/api-tokens",
    title: _ctx.$t('api_tokens')
  }, null, 8, ["title"]))
}